import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Spinner,
} from "react-bootstrap";
import DefaultLayout from "../../../layout/vendor/DefaultLayout";
import { useQuery } from "react-query";
import api from "../../../utils/helper";
import moment from "moment";
import { BadgesComponent } from "../../../components/BadgeRenderer";
import { URLS } from "../../../utils/URL";

const Approvals = () => {
  const navigate = useNavigate();

  const handleView = (course) => {
    navigate("/vendor/approval-list", { state: { course,  viewOnly : false } });
  };

  const { data, isLoading, error } = useQuery(
    ["courses", "vendors/courses"],
    () => api.get("vendors/courses")
  );

  return (
    <>
      <DefaultLayout>
        <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <h2 className="heading text-light px-3 mb-0">Approvals</h2>
            <Badge pill className="header-badge mx-2">
              {data?.data?.data?.filter((c) => c.status == "pending")?.length}{" "}
              Requests
            </Badge>
          </div>
        </div>

        <Container
          fluid
          className="main-container mt-0 mt-md-4 ps-auto ps-md-0"
        >
          <Card className="form-card d-none d-md-block">
            {/* Desktop View Card Header */}
            <Card.Header className="heading d-none d-lg-block">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-2 align-items-center">
                  <h5 className="text-muted mb-0">
                    <span className="text-dark fw-bold"> Approvals</span>
                    <Badge pill className="header-badge mx-2">
                      {
                        data?.data?.data?.filter((c) => c.status == "pending")
                          ?.length
                      }{" "}
                      Requests
                    </Badge>
                  </h5>
                </div>
                <div></div>
              </div>
            </Card.Header>

            {isLoading ? (
              <div className="text-center">
                <Spinner size="md" />
              </div>
            ) : (
              <Card.Body className="p-3">
                {/* Vendor Cards */}
                {console.log(data?.data, "ok")}
                <Row>
                  {data?.data?.data?.filter((c) => c.status == "pending")
                    ?.length == 0 && !isLoading ? (
                    <p className="text-center my-5 text-danger">
                      No courses found!
                    </p>
                  ) : (
                    data?.data?.data
                      ?.filter((c) => c.status == "pending")
                      .map((card) => (
                        <Col md={6} key={card._id} className="mb-3">
                          <Card className="approval-card">
                            <Card.Body style={{ padding: "0.5rem" }}>
                              <div
                                className="d-flex justify-content-between align-items-top"
                                style={{ width: "100%" }}
                              >
                                <div
                                  className="d-flex justify-content-between align-items-center"
                                  style={{ height: "140px" }}
                                >
                                  <img
                                    src={
                                      card.thumbnail_img
                                        ? URLS.IMG_URL + card.thumbnail_img
                                        : "/images/card_image.png"
                                    }
                                    alt="Vendor Logo"
                                    className="img-fluid mb-1 rounded"
                                    style={{ height: "100%" }}
                                    width={140}
                                    height={37}
                                  />

                                  <div className="p-0 ms-3 text-line-height">
                                    <p
                                      className="mb-0 font-16 fw-bold text-truncate"
                                      style={{ maxWidth: "140px" }}
                                      title={card.name}
                                    >
                                      {card.name}
                                    </p>
                                    {console.log(card.createdAt, "ard", card)}
                                    <p className="mb-0 textpara font-12">
                                      Created on:{" "}
                                      {moment(card.createdAt).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </p>
                                    <p className="mb-0 textpara font-12">
                                      Duration: {card.duration}
                                    </p>
                                    <BadgesComponent badges={card.tags} />
                                  </div>
                                </div>

                                <div className="mx-2 text-end mt-2">
                                  <div className="p-0">
                                    <p
                                      className={`mb-0 textpara font-12 text-danger  text-${card.timeToApproveText}`}
                                    >
                                      To be approved in: {card.approvalTimeRemaining}
                                    </p>
                                  </div>

                                  <Button
                                    className="btn-sec mt-5"
                                    onClick={() => handleView(card)}
                                  >
                                    View & Approve
                                  </Button>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))
                  )}
                </Row>
              </Card.Body>
            )}
          </Card>

          <Card className="form-card shadow-sm p-0 mb-4 d-md-none">
            <Card.Body>
              <Card className="form-card ">
                {/* Mobile View Card Header */}
                <Card.Header className="heading d-none d-lg-block">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex gap-2 align-items-center">
                      <h5 className="text-muted venhead mb-0">
                        <span className="text-dark fw-bold"> Approvals</span>
                        <Badge pill className="header-badge mx-2">
                          {
                            data?.data?.data?.filter(
                              (c) => c.status == "pending"
                            )?.length
                          }{" "}
                          Requests
                        </Badge>
                      </h5>
                    </div>
                    <div></div>
                  </div>
                </Card.Header>
                <Card.Body className="p-3">
                  {/* Vendor Cards */}
                  <Row>
                    {data?.data?.data?.filter((c) => c.status == "pending")
                      ?.length == 0 && !isLoading ? (
                      <p className="text-center my-5 text-danger">
                        No courses found!
                      </p>
                    ) : (
                      data?.data?.data
                        ?.filter((c) => c.status == "pending")
                        ?.map((card) => (
                          <Col md={6} key={card.id} className="mb-3">
                            <Card className="approval-card">
                              <Card.Body className="p-2">
                                <div className="justify-content-between align-items-top">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <img
                                      src={
                                        card.cover_img
                                          ? URLS.IMG_URL + card.cover_img
                                          : "/images/card_image.png"
                                      }
                                      alt="Vendor Logo"
                                      className="mb-1 rounded"
                                      width={100}
                                      height={118}
                                    />

                                    <div className="p-0 ms-3 text-line-height">
                                      <p
                                        className="mb-0 font-16 fw-bold text-truncate"
                                        style={{ maxWidth: "130px" }}
                                        title={card.name}
                                      >
                                        {card.name}
                                      </p>
                                      <p className="mb-0 textpara font-12">
                                        Created on:{" "}
                                        {moment(card.createdAt).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </p>
                                      <p className="mb-0 textpara font-12">
                                        Duration: {card.duration}
                                      </p>

                                      <BadgesComponent badges={card.tags} />
                                    </div>
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center mt-2">
                                    <div className="p-0">
                                      <p
                                        className={`mb-0 font-12 approvetext text-${card.timeToApproveText}`}
                                      >
                                        To be approved in: {card.timeToApprove}
                                      </p>
                                    </div>

                                    <Button
                                      className="btn-approval"
                                      onClick={() => handleView(card)}
                                    >
                                      View & Approve
                                    </Button>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        ))
                    )}
                  </Row>
                </Card.Body>
              </Card>
            </Card.Body>
          </Card>
        </Container>
      </DefaultLayout>
    </>
  );
};

export default Approvals;
